/**
 * Пакеты проверки в браузере: получение у сервера (с токеном игрока), сохранение файлов,
 * независимая проверка тем же кодом, что и консольная утилита (@mt/verification).
 */
import { verifyPackage, type SignedPackage, type VerifyReport } from '@mt/verification';
import { authToken } from '../net/client';

export async function fetchPackage(gameId: string): Promise<{ signed: SignedPackage; text: string }> {
  const token = authToken();
  const res = await fetch(`/api/games/${encodeURIComponent(gameId)}/verification`, { headers: token ? { authorization: `Bearer ${token}` } : {} });
  const text = await res.text();
  if (!res.ok) {
    let msg = `ошибка ${res.status}`;
    try {
      msg = (JSON.parse(text) as { message?: string }).message ?? msg;
    } catch {
      /* не JSON */
    }
    throw new Error(msg);
  }
  return { signed: JSON.parse(text) as SignedPackage, text };
}

let cachedKey: string | null = null;
/** Открытый ключ сервера; проверка сверяет с ним ключ в файле. */
export async function serverPublicKey(): Promise<string | undefined> {
  if (cachedKey) return cachedKey;
  try {
    cachedKey = ((await (await fetch('/api/verification-key')).json()) as { publicKey: string }).publicKey;
    return cachedKey;
  } catch {
    return undefined;
  }
}

export async function verify(signed: unknown): Promise<VerifyReport> {
  return verifyPackage(signed, { trustedPublicKey: await serverPublicKey() });
}

export function saveFile(name: string, content: string, mime: string): void {
  const url = URL.createObjectURL(new Blob([content], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

export async function downloadPackage(gameId: string): Promise<SignedPackage> {
  const { signed, text } = await fetchPackage(gameId);
  saveFile(`market-table-${gameId}.json`, text, 'application/json');
  return signed;
}
